// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 可灵2.5视频生成节点样式 */

/* 节点容器 */
.KlingVideoNode-container {
  position: relative;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 320px;
}

.KlingVideoNode-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #06b6d4;
}

/* 标题 */
.KlingVideoNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
}

/* 内容包装器 */
.KlingVideoNode-wrapper {
  padding: 16px;
  width: 320px;
}

/* Handle 样式 */
.KlingVideoNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #06b6d4;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.KlingVideoNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.KlingVideoNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.KlingVideoNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.KlingVideoNode-handle-output {
  border-color: #06b6d4;
  background: #06b6d4;
}

/* Handle 标签 */
.KlingVideoNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.KlingVideoNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.KlingVideoNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(6, 182, 212, 0.45);
  background: linear-gradient(135deg, #22d3ee 0%, #0891b2 100%);
}

/* 可点击标签的按下效果 */
.KlingVideoNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.KlingVideoNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.KlingVideoNode-handle-label-clickable:hover::after {
  opacity: 1;
}

.KlingVideoNode-handle:hover .KlingVideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(6, 182, 212, 0.35);
}

.KlingVideoNode-handle:hover .KlingVideoNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #06b6d4;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(6, 182, 212, 0.2));
}

.KlingVideoNode-handle-prompt .KlingVideoNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.KlingVideoNode-handle-prompt:hover .KlingVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.KlingVideoNode-handle-prompt:hover .KlingVideoNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.KlingVideoNode-handle-image .KlingVideoNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.KlingVideoNode-handle-image:hover .KlingVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.KlingVideoNode-handle-image:hover .KlingVideoNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .KlingVideoNode-handle .KlingVideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(6, 182, 212, 0.35);
}

.react-flow__node.selected .KlingVideoNode-handle-prompt .KlingVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .KlingVideoNode-handle-image .KlingVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes KlingVideoNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.KlingVideoNode-handle:hover .KlingVideoNode-handle-label,
.react-flow__node.selected .KlingVideoNode-handle .KlingVideoNode-handle-label {
  animation: KlingVideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 字段容器 */
.KlingVideoNode-field {
  margin-bottom: 16px;
}

/* 标签 */
.KlingVideoNode-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 13px;
  color: #374151;
}

/* 按钮组 */
.KlingVideoNode-button-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

/* 2列按钮组 */
.KlingVideoNode-button-group-2col {
  grid-template-columns: repeat(2, 1fr);
}

/* 单个按钮 */
.KlingVideoNode-button {
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.KlingVideoNode-button:hover:not(:disabled) {
  border-color: #06b6d4;
  color: #06b6d4;
  background-color: #ecfeff;
}

.KlingVideoNode-button-active {
  border-color: #06b6d4;
  background-color: #06b6d4;
  color: #ffffff;
}

.KlingVideoNode-button-active:hover:not(:disabled) {
  background-color: #0891b2;
  border-color: #0891b2;
}

.KlingVideoNode-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 文本输入框 */
.KlingVideoNode-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s ease;
  background-color: #ffffff;
  color: #374151;
}

.KlingVideoNode-textarea:focus {
  outline: none;
  border-color: #06b6d4;
  background-color: #ecfeff;
}

.KlingVideoNode-textarea:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

.KlingVideoNode-textarea::placeholder {
  color: #9ca3af;
}

/* 小提示 */
.KlingVideoNode-hint-small {
  margin-top: 6px;
  font-size: 11px;
  color: #0891b2;
  line-height: 1.4;
}

/* 提示信息 */
.KlingVideoNode-hint {
  padding: 12px;
  background-color: #cffafe;
  border: 1px solid #06b6d4;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #164e63;
  margin-bottom: 16px;
}

/* 图片预览 */
.KlingVideoNode-image-preview {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #06b6d4;
  background: #f9fafb;
}

.KlingVideoNode-preview-img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 200px;
  object-fit: contain;
}

.KlingVideoNode-image-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(6, 182, 212, 0.95);
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
}

/* 图片占位符 */
.KlingVideoNode-image-placeholder {
  padding: 40px 20px;
  text-align: center;
  background-color: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
}

/* 生成按钮 */
.KlingVideoNode-generate {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(6, 182, 212, 0.3);
}

.KlingVideoNode-generate:hover:not(:disabled) {
  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.4);
  transform: translateY(-1px);
}

.KlingVideoNode-generate:active:not(:disabled) {
  transform: translateY(0);
}

.KlingVideoNode-generate-disabled {
  background: #d1d5db;
  cursor: not-allowed;
  box-shadow: none;
}

/* 错误提示 */
.KlingVideoNode-error {
  margin-top: 12px;
  padding: 12px;
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.5;
}

/* 复制按钮样式 */
.KlingVideoNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.KlingVideoNode-container:hover .KlingVideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.KlingVideoNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

.KlingVideoNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .KlingVideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/KlingVideoNode.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,8CAA8C;EAC9C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,UAAU;AACV;EACE,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* 可灵2.5视频生成节点样式 */\n\n/* 节点容器 */\n.KlingVideoNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 320px;\n}\n\n.KlingVideoNode-container:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #06b6d4;\n}\n\n/* 标题 */\n.KlingVideoNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n}\n\n/* 内容包装器 */\n.KlingVideoNode-wrapper {\n  padding: 16px;\n  width: 320px;\n}\n\n/* Handle 样式 */\n.KlingVideoNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #06b6d4;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.KlingVideoNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.KlingVideoNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.KlingVideoNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.KlingVideoNode-handle-output {\n  border-color: #06b6d4;\n  background: #06b6d4;\n}\n\n/* Handle 标签 */\n.KlingVideoNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.KlingVideoNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.KlingVideoNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(6, 182, 212, 0.45);\n  background: linear-gradient(135deg, #22d3ee 0%, #0891b2 100%);\n}\n\n/* 可点击标签的按下效果 */\n.KlingVideoNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.KlingVideoNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.KlingVideoNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n.KlingVideoNode-handle:hover .KlingVideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(6, 182, 212, 0.35);\n}\n\n.KlingVideoNode-handle:hover .KlingVideoNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #06b6d4;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(6, 182, 212, 0.2));\n}\n\n.KlingVideoNode-handle-prompt .KlingVideoNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.KlingVideoNode-handle-prompt:hover .KlingVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.KlingVideoNode-handle-prompt:hover .KlingVideoNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.KlingVideoNode-handle-image .KlingVideoNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.KlingVideoNode-handle-image:hover .KlingVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.KlingVideoNode-handle-image:hover .KlingVideoNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .KlingVideoNode-handle .KlingVideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(6, 182, 212, 0.35);\n}\n\n.react-flow__node.selected .KlingVideoNode-handle-prompt .KlingVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .KlingVideoNode-handle-image .KlingVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes KlingVideoNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.KlingVideoNode-handle:hover .KlingVideoNode-handle-label,\n.react-flow__node.selected .KlingVideoNode-handle .KlingVideoNode-handle-label {\n  animation: KlingVideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 字段容器 */\n.KlingVideoNode-field {\n  margin-bottom: 16px;\n}\n\n/* 标签 */\n.KlingVideoNode-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* 按钮组 */\n.KlingVideoNode-button-group {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n/* 2列按钮组 */\n.KlingVideoNode-button-group-2col {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n/* 单个按钮 */\n.KlingVideoNode-button {\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.KlingVideoNode-button:hover:not(:disabled) {\n  border-color: #06b6d4;\n  color: #06b6d4;\n  background-color: #ecfeff;\n}\n\n.KlingVideoNode-button-active {\n  border-color: #06b6d4;\n  background-color: #06b6d4;\n  color: #ffffff;\n}\n\n.KlingVideoNode-button-active:hover:not(:disabled) {\n  background-color: #0891b2;\n  border-color: #0891b2;\n}\n\n.KlingVideoNode-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* 文本输入框 */\n.KlingVideoNode-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n  color: #374151;\n}\n\n.KlingVideoNode-textarea:focus {\n  outline: none;\n  border-color: #06b6d4;\n  background-color: #ecfeff;\n}\n\n.KlingVideoNode-textarea:disabled {\n  background-color: #f3f4f6;\n  cursor: not-allowed;\n}\n\n.KlingVideoNode-textarea::placeholder {\n  color: #9ca3af;\n}\n\n/* 小提示 */\n.KlingVideoNode-hint-small {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #0891b2;\n  line-height: 1.4;\n}\n\n/* 提示信息 */\n.KlingVideoNode-hint {\n  padding: 12px;\n  background-color: #cffafe;\n  border: 1px solid #06b6d4;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #164e63;\n  margin-bottom: 16px;\n}\n\n/* 图片预览 */\n.KlingVideoNode-image-preview {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 2px solid #06b6d4;\n  background: #f9fafb;\n}\n\n.KlingVideoNode-preview-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-height: 200px;\n  object-fit: contain;\n}\n\n.KlingVideoNode-image-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(6, 182, 212, 0.95);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* 图片占位符 */\n.KlingVideoNode-image-placeholder {\n  padding: 40px 20px;\n  text-align: center;\n  background-color: #f9fafb;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* 生成按钮 */\n.KlingVideoNode-generate {\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(6, 182, 212, 0.3);\n}\n\n.KlingVideoNode-generate:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);\n  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.4);\n  transform: translateY(-1px);\n}\n\n.KlingVideoNode-generate:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.KlingVideoNode-generate-disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* 错误提示 */\n.KlingVideoNode-error {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fee2e2;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  color: #991b1b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* 复制按钮样式 */\n.KlingVideoNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.KlingVideoNode-container:hover .KlingVideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.KlingVideoNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n.KlingVideoNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .KlingVideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
